import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row flex-column flex-xl-row py-5" }
const _hoisted_2 = { class: "col align-self-center pt-0 pt-xl-5 mt-5 mb-0 mb-xl-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "figure-title mb-4 text-start fw-semibold" }, " Donations Per Location ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "figure-description my-2 text-justify opacity-75" }, " Et has minim elitr intellegat. Mea aeterno eleifend antiopam ad, nam no suscipit quaerendum. At nam minimum ponderum. Est audiam animal molestiae te. Ex duo eripuit mentitum. ", -1)
const _hoisted_5 = { class: "row my-4" }
const _hoisted_6 = ["index"]
const _hoisted_7 = { class: "flex-grow-1 align-self-stretch text-start" }
const _hoisted_8 = { class: "text-capitalize" }
const _hoisted_9 = { class: "m-0 fw-bold" }
const _hoisted_10 = { class: "col align-self-center mt-3 mt-xl-5 mb-5" }
const _hoisted_11 = { class: "dropdown float-end mb-4" }
const _hoisted_12 = { class: "dropdown-menu dropdown-menu-end" }
const _hoisted_13 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Bar = _resolveComponent("Bar")!

  return (_openBlock(), _createElementBlock("div", {
    id: "donationCount",
    class: _normalizeClass(["container-fluid", {
      'bg-white text-black': _ctx.role === 'Donor' || _ctx.role === 'Charity',
      'bg-dark text-white': _ctx.role === 'Administrator',
    }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["container", {
        'border-2 border-bottom': _ctx.role === 'Donor' || _ctx.role === 'Charity',
      }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chartData.labels, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "chart-legend col-6 col-xxl my-2 my-xxl-0 d-flex",
                key: index,
                index: index
              }, [
                _createElementVNode("div", {
                  class: "pill rounded-pill me-3 mt-2",
                  style: _normalizeStyle({
                  backgroundColor: _ctx.chartData.datasets
                    .at(0)
                    .backgroundColor.at(index),
                })
                }, null, 4),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("small", _hoisted_8, _toDisplayString(item.toLowerCase()), 1),
                  _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.chartData.datasets.at(0).data.at(index)) + " donations ", 1)
                ])
              ], 8, _hoisted_6))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["btn dropdown-toggle fs-6", `text-${
                _ctx.role === 'Donor' || _ctx.role === 'Charity' ? 'black' : 'white'
              }`]),
              "data-bs-toggle": "dropdown",
              "aria-expanded": "false"
            }, " Government level: " + _toDisplayString(_ctx.governmentLevel), 3),
            _createElementVNode("ul", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.governmentLevels, (level) => {
                return (_openBlock(), _createElementBlock("li", { key: level }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "dropdown-item",
                    onClick: ($event: any) => (_ctx.$emit('updateGovernmentLevel', level))
                  }, _toDisplayString(level), 9, _hoisted_13)
                ]))
              }), 128))
            ])
          ]),
          _createVNode(_component_Bar, {
            id: "donationsPerLocation",
            options: _ctx.chartOptions,
            data: _ctx.chartData
          }, null, 8, ["options", "data"])
        ])
      ])
    ], 2)
  ], 2))
}